<template>
  <loading-page v-if="loading" />

  <policies-form
    v-else
    details
    @edit="onEdit"
    @close="onClose"
  />
</template>
<script>
import PoliciesForm from './ImagePoliciesForm.vue'
import redirectError from '@/services/redirectError'

export default {
  name: 'RequestPolicyEdit',
  components: { PoliciesForm },
  data() {
    return {
      imageId: null,
    }
  },
  computed: {
    loading() {
      return this.$store.state.imagePolicies.gettingPolicy
    },
  },
  created() {
    this.imageId = this.$route.params.imageId
    this.$store.dispatch('imagePolicies/getImagePolicy', this.imageId)
      .catch(err => redirectError(err, this.$router, this.$route.path))
  },
  methods: {
    onEdit(policy) {
      this.$store.dispatch('imagePolicies/updateImagePolicy', policy)
        .then(() => {
          this.successToast('Image policy was updated')
          this.onClose()
        }).catch(error => { this.errorToast(error.response?.data?.errors[0] || 'Something went wrong while updating policy.') })
    },
    onClose() {
      this.$router.push({ name: 'image-policies' })
    },
  },
}
</script>
